import { z } from 'zod';

import { ProjectIdSchema } from './project';
import { AppUserIdSchema } from '../user/user';

export const ProjectMemberRoleSchema = z.enum(['admin', 'editor', 'viewer']);
export type ProjectMemberRole = z.infer<typeof ProjectMemberRoleSchema>;

export const ProjectMemberSchema = z.object({
  id: z.string(),
  projectId: ProjectIdSchema,
  userId: AppUserIdSchema,
  role: ProjectMemberRoleSchema,
  userName: z.string(),
  userEmail: z.string(),
});

export type ProjectMember = z.infer<typeof ProjectMemberSchema>;

export const AddProjectMemberInputSchema = z
  .object({
    userId: AppUserIdSchema,
    role: ProjectMemberRoleSchema,
  })
  .strict();

export type AddProjectMemberInput = z.infer<typeof AddProjectMemberInputSchema>;

export const UpdateProjectMemberRoleInputSchema = z
  .object({
    role: ProjectMemberRoleSchema,
  })
  .strict();

export type UpdateProjectMemberRoleInput = z.infer<typeof UpdateProjectMemberRoleInputSchema>;
